import { Subject } from "rxjs";
import { ActionBarDetailHandlerModel } from "./actionbar-detail-handler.model";

export class ActionbarDetailNotifier {
    init: (handler: ActionBarDetailHandlerModel) => void = (handler: ActionBarDetailHandlerModel) => { };
    updateState: (handler: ActionBarDetailHandlerModel) => void = (handler: ActionBarDetailHandlerModel) => { };
    getCurrentState: () => ActionBarDetailHandlerModel = () => { return null; };
    action$: Subject<string> = new Subject<string>();
}